import React from "react";

import { Block, Dispatch } from "../../types";
import { blockIsTable } from "../../util";
import { TableEditor as TableEditorComponent } from "./TableEditor";
import { TextEditor as TextEditorComponent } from "./TextEditor";

type Props = Readonly<{
  block: Block;
  active: boolean;
  selectedCellId: string;
  disabled: boolean;
  dispatch: Dispatch;
  readonly: boolean;
}>;

const TableEditor = React.memo(TableEditorComponent);
const TextEditor = React.memo(TextEditorComponent);

export const Editor = ({ block, disabled, dispatch, active, selectedCellId, readonly }: Props) => {
  if (blockIsTable(block)) {
    return <TableEditor 
      block={block} 
      disabled={disabled} 
      dispatch={dispatch} 
      active={active && !readonly} 
      selectedCellId={selectedCellId} 
    />;
  }
  return <TextEditor 
    block={block} 
    disabled={disabled}
     dispatch={dispatch} 
     active={active && !readonly} 
     />;
};
